<template>
	<div ref="notifications" class="notification-container dark" role="status">
		<Transition name="notify">
			<TransitionGroup v-if="$notify.notifications?.length" name="notify" tag="ul">
				<li
					v-for="notification in $notify.notifications"
					:key="notification.id"
					data-test="notification"
					class="notification"
					:class="{
						'notification-warning': notification.type === 'warning',
						'notification-error': notification.type === 'error',
						'notification-success': notification.type === 'success',
					}"
					:style="{marginTop: notification.offset && notification.offset + 'px'}"
				>
					<button
						class="float-right link-gray z-50 -mr-4 relative"
						title="Close"
						data-test="notification-close-button"
						@click="close(notification)"
					>
						<BaseIcon name="mono/delete" />
					</button>
					<h4 v-if="notification.title" class="text-gray-200 font-semibold">
						{{ notification.title }}
					</h4>
					<div v-if="notification.message" class="text-gray-400 mt-4">
						<!-- eslint-disable-next-line vue/no-v-html -->
						<div v-if="notification.dangerouslyUseHTMLString" v-html="notification.message" />
						<template v-else> {{ notification.message }} </template>
					</div>
					<button v-if="notification.onClick" class="absolute inset-0 z-10" @click="onClick(notification)">
						<span class="sr-only">{{ notification.message }}</span>
					</button>
				</li>
			</TransitionGroup>
		</Transition>
	</div>
</template>

<script>
export default {
	mounted() {
		document.body.appendChild(this.$refs.notifications)
	},
	methods: {
		close(notification) {
			notification.onClose && notification.onClose()
			this.$notify.remove(notification.id)
		},
		onClick(notification) {
			notification.onClick && notification.onClick()
			this.close(notification)
		},
	},
}
</script>

<style scoped>
.notification-container {
	position: fixed;
	top: 60px;
	right: 16px;
	z-index: 9999;
	max-width: 360px;
}

.notification {
	position: relative;
	background: var(--gray-800);
	border-radius: var(--border-radius-md);
	border: 1px solid var(--gray-600);
	padding: 8px 12px;
	border-bottom: 3px solid var(--gray-600);
	margin-bottom: 8px;
	min-width: 200px;
	white-space: pre-line;
}

.notification-error {
	border-bottom: 3px solid var(--red-500);
}

.notification-success {
	border-bottom: 3px solid var(--green-500);
}

.notification-warning {
	border-bottom: 3px solid var(--yellow-500);
}
</style>
